import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  optional: {
    id: 'react-components.InWqys',
    defaultMessage: 'Optional',
  },
});
